import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './FloatingContact.css';
import { LanguageContext } from '../App';
import { useAuth } from '../context/AuthContext';
import { translations } from '../utils/translations';

function FloatingContact() {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.en;
  const { user, intakeComplete } = useAuth();

  const handleLegalHelpClick = () => {
    if (!user) {
      navigate('/intake?redirect=contact&guest=true');
      return;
    }

    if (!intakeComplete) {
      navigate('/intake?redirect=contact');
      return;
    }

    navigate('/contact-flow');
  };

  return (
    <div className="floating-contact">
      <button
        className="floating-button"
        onClick={handleLegalHelpClick}
        title={t.buttons.getHelp}
      >
        {t.buttons.getHelp}
      </button>
    </div>
  );
}

export default FloatingContact;
